import jwtDecode from 'jwt-decode'
import { computed, Ref, ref } from 'vue'

import { UserFields, useUserData } from '@/shared/composables/local-storage'
import { Guest } from '@/shared/types/api'
import { UserRoles } from '@/shared/types/router'
import { deleteCookie, getCookie } from '@/shared/utils/cookie'

const guestData: Ref<Guest | undefined> = ref()
const isAuthenticated: Ref<boolean> = computed(() => Boolean(guestData.value))
const GUEST_TOKEN_COOKIE_NAME = 'Authorization'
const GUEST_TOKEN_COOKIE_NAME_DEPRECATED = 'set-cookie'

export const useGuestAuth = () => {
  const { getField, setField } = useUserData()
  const setAuthGuestData = (jwt: string) => {
    const guest: Guest = {
      ...jwtDecode(jwt),
      authToken: jwt,
    }
    guestData.value = guest
    setField('authToken', guest.authToken)
    setField('exp', guest.exp)
    setField('guestToken', guest.guestToken)
    setField('pServed', guest.pServed)
    setField(UserFields.USER_ROLE, UserRoles.GUEST)
  }

  const loadAuthGuestData = () => {
    const { setAuthGuestData } = useGuestAuth()
    const encoded: string | undefined = getCookie(GUEST_TOKEN_COOKIE_NAME) ?? getCookie(GUEST_TOKEN_COOKIE_NAME_DEPRECATED) ?? getField('authToken')
    if (!encoded) return
    setAuthGuestData(encoded)
  }

  const logout = (): void => {
    guestData.value = undefined
    deleteCookie('set-cookie')
  }

  return {
    currentGuest: computed(() => guestData.value),
    isAuthenticated,
    logout,
    setAuthGuestData,
    loadAuthGuestData,
  }
}
